<script setup>
import { defineProps, computed, onMounted, onUnmounted, ref } from "vue"
import CTAFindInstaller from "@/js/partials/CTAFindInstaller.vue"

const props = defineProps({
  entry: {
    required: true,
    type: Object,
  },
})

const items = computed(() =>
  props.entry.fields.blocks
    .filter((o) => o.fields.navigationTitle && o.fields.id)
    .map((o) => o.fields)
)
const isSticky = ref(false)

const handleScroll = () => {
  const navsWrapperBottom = document
    .querySelector(".summary-navs-wrapper")
    .getBoundingClientRect().bottom
  const offsetHeight = 80 /* Header height */
  const contentBottom = document
    .querySelector(".main-content")
    .getBoundingClientRect().bottom
  isSticky.value =
    navsWrapperBottom - offsetHeight < 0 && contentBottom > window.innerHeight
}

onMounted(() => {
  window.addEventListener("scroll", handleScroll)
})

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll)
})
</script>

<template>
  <aside class="relative hidden lg:block w-96">
    <div class="bg-orange-100 px-6 py-6 rounded-lg summary-navs-wrapper">
      <h4 class="text-2xl font-bold leading-snug tracking-tight mb-4">
        Sommaire
      </h4>
      <ul class="font-medium -my-1">
        <li v-for="(item, i) in items" :key="i" class="py-1">
          <router-link
            :class="[
              'flex items-center hover:underline',
              !$route.hash.includes(item.id)
                ? 'font-normal text-slate-600 dark:text-slate-400'
                : 'font-medium text-blue-600 before:bg-blue-400',
            ]"
            :to="{ hash: '#' + item.id }"
          >
            <span>{{ item.navigationTitle }}</span>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="mt-8">
      <CTAFindInstaller
        display="vertical"
        :class="{ 'sticky-cta w-96': isSticky }"
      />
    </div>
  </aside>
</template>
<style scoped>
.sticky-cta {
  position: fixed;
  top: 112px; /* height of header 80px + 32px for mt-8 */
}
</style>
